import React from "react";

const InputField = (props) => {
  return <input className="form-control" {...props} />;
};

export default InputField;
